/**
 * Paleta y tokens del mástil luthería (referencia: SongFretboardFlow / Canciones).
 * Usar en GuitarNeck, MiniChordNeck y cualquier SVG de diapasón estático.
 */
export const LUTHERIE_PALETTE = {
  fingerboard: "#3D2B1F",
  fingerboardDark: "#2A1D14",
  fingerboardLight: "#4D3A2E",

  fretWire: "#9A958D",
  fretWireHighlight: "#B8B3AB",
  nut: "#EDE4D0",
  nutShadow: "#C8BCA8",

  stringSteel: "#C5C1B5",
  stringBronze: "#B8975A",
  stringShadow: "rgba(0,0,0,0.4)",

  inlayPearl: "#E8E2D6",
  inlayGold: "#B8956A",
  inlayGlow: "rgba(184,149,106,0.25)",

  noteBg: "rgba(250,246,240,0.95)",
  noteBorder: "#B8956A",
  noteBorderActive: "#7B2335",
  noteText: "#2C2825",
  noteTextActive: "#7B2335",
  noteShadow: "rgba(0,0,0,0.35)",
  noteActiveGlow: "rgba(123,35,53,0.35)",

  barline: "rgba(180,170,155,0.35)",
  barlineStrong: "rgba(180,170,155,0.55)",

  bgPanel: "#FDF8F0",
  bgBorder: "#E8E0D4",
} as const;

/** Fondo del diapasón en modo oscuro / paneles (Canciones). */
export const LUTHERIE_FRETBOARD_DARK = LUTHERIE_PALETTE.fingerboardDark;

export const LUTHERIE_STRING_MATERIALS = [
  { wound: false, stroke: 1.05, shadow: 1.35 },
  { wound: false, stroke: 1.2, shadow: 1.5 },
  { wound: false, stroke: 1.38, shadow: 1.68 },
  { wound: true, stroke: 1.88, shadow: 2.35 },
  { wound: true, stroke: 2.28, shadow: 2.9 },
  { wound: true, stroke: 2.72, shadow: 3.45 },
] as const;
